import { Box } from '@chakra-ui/react'
import { renderDraftEmptyCustomisedPage, renderPageContent, reorderPinnedContentFirst } from '../helpers/dsr-helpers'
import { useState, useEffect, useRef } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import DsrActionListPage from '../dsr-action-list/DsrActionListPage'
import OverviewDraftPage from './overview/OverviewDraftPage'
import DsrInsightsPage from '../dsr-analytics/DsrInsightsPage'
import DsrTeamNotesPage from '../dsr-analytics/DsrTeamNotesPage'
import DsrRoomSettingsPage from '../dsr-analytics/DsrRoomSettingsPage'
import DsrSharedDocsPage from '../dsr-shared-docs/DsrSharedDocsPage';
import DsrTemplateSettingsPage from '../dsr-analytics/DsrTemplateSettingsPage'
import DsrProspectTeamNotesPage from '../dsr-prospecting/DsrProspectTeamNotesPage'
import DsrProspectRoomSettingsPage from '../dsr-prospecting/DsrProspectRoomSettingsPage'
import DsrFaqDisplay from '../dsr-content-components/dsr-faq/DsrFaqDisplay'


function RenderDraftSubpageContent({
  dsrPagesLocalState,
  selectedDisplaySubpage,
  selectedDisplayPageId,
  extraHeaderLayoutOffset,
  dsrId,
  dsrLastUpdated,
  dsrTeamMembersRedux,
  dsrProperties,
  dsrActionList,
  replacePages,
  handleChangeUserActionRequired,
  isMobileView
}) {
  const pageArray = dsrPagesLocalState;
  const [fixedSubpageToDisplay, setFixedSubpageToDisplay] = useState("")
  const [pageToDisplay, setPageToDisplay] = useState(null)


  // Initialize
  useEffect(() => {
    if (pageArray) {
      let foundPageToDisplay = "";

      if (!selectedDisplayPageId) {
        foundPageToDisplay = pageArray?.filter(page => page.pageType === "overview");
      } else if (selectedDisplayPageId) {
        if (selectedDisplayPageId === "no-visible-pages") {
          // Scenario: When user go from edit to preview and back to edit, and inherit the 'no-visible-pages' page id value
          foundPageToDisplay = pageArray?.filter(page => page.pageId === pageArray[0].pageId);
          setPageToDisplay(foundPageToDisplay[0])
        } else {
          foundPageToDisplay = pageArray?.filter(page => page.pageId === selectedDisplayPageId);
        }
       
      }
      
      if (foundPageToDisplay) {
        setPageToDisplay(foundPageToDisplay[0])
      }
    }

  }, [pageArray, selectedDisplayPageId]);

  useEffect(() => {
    // For MAP page
    if (pageArray) {

      if (selectedDisplaySubpage === "overview-subpage") {
        const foundPageToDisplay = pageArray?.filter(page => page.pageType === "overview");

        if (foundPageToDisplay) {
          setPageToDisplay(foundPageToDisplay[0])
        }
      } else {
        setFixedSubpageToDisplay(selectedDisplaySubpage ? selectedDisplaySubpage : "")
      }

    } else {
      setFixedSubpageToDisplay("")
    }
  }, [selectedDisplaySubpage, pageArray])


  // Render Content
  const updateDsrPages = (newPage) => {
    if (newPage) {
      const updatedPages = dsrPagesLocalState.map((page) => (page.pageId !== newPage.pageId ? page : newPage))

      replacePages(updatedPages)
    }
  }

  const pickAndRenderPage = () => {
    if (fixedSubpageToDisplay) {
      switch (fixedSubpageToDisplay) {
        case 'action-list-subpage': {
          return (
            <DsrActionListPage
              dsrId={dsrId}
              dsrActionList={dsrActionList}
              dsrTeamMembers={dsrTeamMembersRedux}
              dsrProperties={dsrProperties}
            />
          )
        }
        case ('faq-subpage'): {
          return (
           <DsrFaqDisplay />  
          )
        }
        case ('insights-subpage'): {
          return (
            <DsrInsightsPage
              dsrId={dsrId}
            />
          )
        }
        case ('team-notes-subpage'): {
          return (
            <DsrTeamNotesPage
              dsrId={dsrId}
              dsrProperties={dsrProperties}
            />
          )
        }
        case ('template-settings-subpage'): {
          return (
            <DsrTemplateSettingsPage
              dsrProperties={dsrProperties}
            />
          )
        }

        case ('shared-docs-folder-subpage'): {
          return (
            <DsrSharedDocsPage
              dsrId={dsrId}
              dsrTeamMembers={dsrTeamMembersRedux}
              handleChangeUserActionRequired={handleChangeUserActionRequired}
              altPageNames={dsrProperties?.altPageNames}
            />
          )
        }
        case ('room-settings-subpage'): {
          return (
            <DsrRoomSettingsPage
              dsrId={dsrId}
              dsrProperties={dsrProperties}
            />
          )
        }
        case ('prospect-room-settings-subpage'): {
          return (
              <DsrProspectRoomSettingsPage
                pDsrId={dsrId}
                dsrProperties={dsrProperties}
              />
          )
        }

        case ('prospector-team-notes-subpage'): {
              return (
                <DsrProspectTeamNotesPage
                  pDsrId={dsrId}
                  dsrProperties={dsrProperties}
                />
              )
        }
        case ('overview-subpage'):
        case ('updates-subpage'): {
          return null
        }
        default: {
          console.log(`There is no subpage type: ${fixedSubpageToDisplay}`)
          return null;
        }

      }
    } else if (!fixedSubpageToDisplay && pageToDisplay) {

      const { pageType, pageTitle, altPageTitle, pageContent } = pageToDisplay || {}

      switch (pageType) {
        case 'overview':
          const {
            pageSubTitle,
            mainContactUserId,
            loomWelcomeVideo,
            textTileDescription
          } = pageToDisplay || {}

          return (
            <OverviewDraftPage
              dsrPagesLocalState={dsrPagesLocalState}
              pageContent={pageContent}
              pageTitle={pageTitle}
              pageSubTitle={pageSubTitle}
              mainContactUserId={mainContactUserId}
              dsrTeamMembers={dsrTeamMembersRedux}
              loomWelcomeVideo={loomWelcomeVideo}
              textTileDescription={textTileDescription}
              dsrLastUpdated={dsrLastUpdated}
            />
          )
        case 'customised-page':
          return (
            <CustomizedPage
              page={pageToDisplay}
              updateDsrPages={updateDsrPages}
              pageTitle={pageTitle}
              isMobileView={isMobileView}
              dsrPages={pageArray}
              dsrProperties={dsrProperties}
            />
          )
        case 'faq':
          return (
            <Faq
              pageContent={pageContent}
              pageTitle={pageTitle}
              altPageTitle={altPageTitle}
            />
          )
        case 'customer-references':
          return (
            <CustomerReferences
              pageContent={pageContent}
              pageTitle={pageTitle}
            />
          )
        default: {
          console.log('There is no pageContent type:', pageType)
          return null
        }
      }
    }

  }

  return <Box mt={!extraHeaderLayoutOffset && '1.5em'}>
    {pickAndRenderPage()}
  </Box>
}


const CustomizedPage = ({ page, updateDsrPages, pageTitle, isMobileView, dsrPages, dsrProperties }) => {
    const pageRef = useRef(false);
  
    useEffect(() => {
      if (pageRef.current && !isMobileView) {
        const elementPosition = pageRef.current.getBoundingClientRect().top;
        const offset = 200; // Offset (200px)
  
        window.scrollTo({
          top: elementPosition - offset, // Scroll to the position minus the offset
          // behavior: 'smooth',
        });
      }
    }, [pageTitle]); 

  return (
    <Box ref={pageRef}>
      {renderDraftEmptyCustomisedPage(dsrPages, updateDsrPages, page, dsrProperties)}
    </Box>
  )
}
const Faq = ({ pageContent, altPageTitle }) => {
  return (
    <Box>
      {renderPageContent(pageContent,null, null, altPageTitle)}
    </Box>
  )
}
const CustomerReferences = ({ pageContent, pageTitle }) => {
  // Reorder array to display pinned content first, if applicable
  const pinnedPageContent = reorderPinnedContentFirst(pageContent)

  return (
    <Box>
      <Box mb="1.25em" fontWeight="600" fontSize="1.5em" lineHeight="2em" color="brandDark.500">
        {pageTitle}
      </Box>
      {renderPageContent(pinnedPageContent)}
    </Box>
  )
}

const mapStateToProps = (state) => ({
  selectedDisplaySubpage: state.changeDsrPage.selectedDisplaySubpage,
  dsrTeamMembersRedux: state.dsrTeamMembers.members,
  selectedDisplayPageId: state.changeDsrPage.selectedDisplayPageId,
  isMobileView: state.mobileViewMode.isMobileView
})

export default withRouter(connect(mapStateToProps)(RenderDraftSubpageContent))
